import { useEffect } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { dashboardFor } from '@/lib/auth/dashboardFor'
import { webUrl } from '@/constants/site'
import { LoadingSpinner } from '@/components/shared/LoadingSpinner'

function FullScreenSpinner() {
  return (
    <div className="flex h-screen items-center justify-center">
      <LoadingSpinner size="lg" />
    </div>
  )
}

/** Redirect full-page verso un URL esterno (sito pubblico www). */
export function ExternalRedirect({ to }: { to: string }) {
  useEffect(() => {
    window.location.replace(to)
  }, [to])
  return <FullScreenSpinner />
}

/** /blog/:slug → equivalente su www. */
export function BlogSlugRedirect() {
  const { slug } = useParams<{ slug: string }>()
  return <ExternalRedirect to={webUrl(slug ? `/blog/${slug}` : '/blog')} />
}

/**
 * Root e catch-all, auth-aware:
 *  • utente loggato → dashboard del suo ruolo
 *  • ospite        → home del sito pubblico www (esterno)
 */
export function RootRedirect() {
  const { isAuthenticated, isLoading, user } = useAuth()

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      window.location.replace(webUrl('/'))
    }
  }, [isLoading, isAuthenticated])

  if (isLoading) return <FullScreenSpinner />
  if (isAuthenticated && user) return <Navigate to={dashboardFor(user.role)} replace />
  return <FullScreenSpinner />
}
